import React from 'react'
import Flipkart from '@assets/images/icon/flipkart.svg'
import Dailyhunt from '@assets/images/icon/dailyhunt.svg'
import Pringles from '@assets/images/icon/pringles.svg'
import InsiderIn from '@assets/images/icon/insider-in.svg'
import Mobi from '@assets/images/icon/mobi.svg'
import Beardo from '@assets/images/icon/beardo.svg'

function AdvertisePartnersRightToLeft() {
  return (
    <div className="ticker right-to-left">
      <div className="ticker__wrap">
        <div className="ticker__content">
          <div className="partnersbox">
            <img src={Flipkart.src} alt="Flipkart" />
          </div>
          <div className="partnersbox">
            <img src={Dailyhunt.src} alt="Dailyhunt" />
          </div>
          <div className="partnersbox">
            <img src={Pringles.src} alt="Pringles" />
          </div>
          <div className="partnersbox">
            <img src={InsiderIn.src} alt="InsiderIn" />
          </div>
          <div className="partnersbox">
            <img src={Mobi.src} alt="Mobi" />
          </div>
          <div className="partnersbox">
            <img src={Beardo.src} alt="Beardo" />
          </div>
          <div className="partnersbox">
            <img src={Flipkart.src} alt="Flipkart" />
          </div>
          <div className="partnersbox">
            <img src={Dailyhunt.src} alt="Dailyhunt" />
          </div>
          <div className="partnersbox">
            <img src={Pringles.src} alt="Pringles" />
          </div>
          <div className="partnersbox">
            <img src={InsiderIn.src} alt="InsiderIn" />
          </div>
          <div className="partnersbox">
            <img src={Mobi.src} alt="Mobi" />
          </div>
          <div className="partnersbox">
            <img src={Beardo.src} alt="Beardo" />
          </div>
        </div>
        <div className="ticker__content">
          <div className="partnersbox">
            <img src={Flipkart.src} alt="Flipkart" />
          </div>
          <div className="partnersbox">
            <img src={Dailyhunt.src} alt="Dailyhunt" />
          </div>
          <div className="partnersbox">
            <img src={Pringles.src} alt="Pringles" />
          </div>
          <div className="partnersbox">
            <img src={InsiderIn.src} alt="InsiderIn" />
          </div>
          <div className="partnersbox">
            <img src={Mobi.src} alt="Mobi" />
          </div>
          <div className="partnersbox">
            <img src={Beardo.src} alt="Beardo" />
          </div>
          <div className="partnersbox">
            <img src={Flipkart.src} alt="Flipkart" />
          </div>
          <div className="partnersbox">
            <img src={Dailyhunt.src} alt="Dailyhunt" />
          </div>
          <div className="partnersbox">
            <img src={Pringles.src} alt="Pringles" />
          </div>
          <div className="partnersbox">
            <img src={InsiderIn.src} alt="InsiderIn" />
          </div>
          <div className="partnersbox">
            <img src={Mobi.src} alt="Mobi" />
          </div>
          <div className="partnersbox">
            <img src={Beardo.src} alt="Beardo" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdvertisePartnersRightToLeft
